import { render, staticRenderFns } from "./HeaderResize.vue?vue&type=template&id=88743498"
import script from "./HeaderResize.vue?vue&type=script&lang=js"
export * from "./HeaderResize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports